import { ThemeProvider } from "@mui/system";
// import { theme } from "./Customization/Theme";
import RootNavigator from "./Routes/RootNavigator";
import { Provider } from "react-redux";
import CustomSnackbarProvider from "./Hooks/useNotification/CustomSnackbarProvider";
import store, { useAppDispatch } from "./Store";
import { useAppSelector } from "./Store";
import { useAuthStore } from "./Store/Slices/AuthSlice";
import { createDynamicTheme } from "./Customization/DynamicTheme";
import{theme as defaultTheme} from "./Customization/Theme"
import { validateToken } from "./Utils/Utils";
import { useEffect, useState } from "react";
import { ThemeProvider as StyledThemeProvider } from "styled-components";
import { domainDetails } from "./Store/Slices/SubAccount/subaccount.selectors";
import { SubAccountActions } from "./Store/Slices/SubAccount/subaccount.actions";
import getPublicAssets from "./Services/s3bucket";
import useFavicon from "./Hooks/useFavicon";
import { ColorUtils } from "./Utils/ColorUtils";



validateToken();



const ThemedApp = () => {
  // const { primaryColor, secondaryColor } = useAppSelector((state) => state.theme);

  const dispatch = useAppDispatch();
  const domainDetailsData:any=useAppSelector(domainDetails)
  useFavicon();


  // const updateFavicon = (iconUrl: string) => {
  //   let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
  //   if (link) {
  //     link.href = iconUrl;
  //   } else {
  //     link = document.createElement("link");
  //     link.rel = "icon";
  //     link.href = iconUrl;
  //     document.head.appendChild(link);
  //   }
  // };

  useEffect(() => {
    // if(window.location.hostname!== process.env.REACT_APP_DOMAIN_NAME){
      dispatch(SubAccountActions.getDomainDetails({ domain: "google.com" }) as any);
    // }
    
  }, []);

  // window.location.hostname!== process.env.REACT_APP_DOMAIN_NAME &&
  
  // useEffect(() => {
  //   const faviconUrl = window.location.hostname !== process.env.REACT_APP_DOMAIN_NAME ? domainDetailsData?.image : (window.location.hostname === process.env.REACT_APP_DOMAIN_NAME) ? "/favicon.png" : ""; 
  //   updateFavicon(faviconUrl);
  // }, [domainDetailsData?.image]); 


const { userConfig }: any = useAppSelector(useAuthStore);
const accountType=userConfig?.payload.sub_account_type ?? "";
console.log("Id",userConfig?.payload?.reseller_details?.id);
const theme =!accountType?defaultTheme:createDynamicTheme(userConfig?.payload?.reseller_details?.primaryColor || "#0000ff", userConfig?.payload?.reseller_details?.secondaryColor || "#000000",userConfig?.payload?.reseller_details?.buttonHoverColor);
  return (
      <ThemeProvider theme={theme}>
        <StyledThemeProvider theme={theme}>
        <CustomSnackbarProvider>
          <RootNavigator />
        </CustomSnackbarProvider>
        </StyledThemeProvider>
      </ThemeProvider>
  );
};

export default ThemedApp;
